import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { Logo } from '../logo/Logo'
import { Input, Icon, Button, Row, Col } from 'antd'
import queryString from 'query-string'
import { validateUserInvitation, setRegisterUser, isDoneInvitation } from '../../actions/InviteAction'
import Loading from '../loading/Loading'
import { sendNotification } from '../../utils/index'
import welcomeImg from '../../assets/images/img-bienvenido.jpg'
import './AcceptInvitation.css'


export class AcceptInvitation extends Component {
  constructor(props) {
    super(props)

    this.state = {
      username: '',
      email: '',
      password: '',
      confirmPassword: '',
      showErrorMessage: false,
      showRegisterAccountMessage: false,
      showCreatedAccountMessage: false
    }

    this.colProps = {
      xs: 20,
      sm: 20,
      md: 12,
      lg: 8,
      xl: 6,
      style: {
        marginTop: 10
      }
    }
  }
  componentDidMount() {
    const { error, user } = this.props
    this.props.isDoneInvitation()
    if (!error && !user) {
      let qs = queryString.parse(this.props.location.search)
      if (qs && qs.webToken) {
        this.props.validateUserInvitation(qs.webToken)
      } else {
        this.props.history.push('/')
      }
    } else if (user && !error) {
      this.setState({
        username: user.name,
        email: user.email
      })
    }
  }

  componentDidUpdate(prevProps) {
    const { error, user, validate, intl } = this.props

    if (prevProps.user !== user) {
      this.setState({
        username: user.name,
        email: user.email
      })
    }

    if (validate && !user._id && prevProps.validate !== validate) {
      sendNotification('success', intl, intl.formatMessage({ id: 'registered_account' }))
      this.setState({
        showCreatedAccountMessage: true,
        showRegisterAccountMessage: false,
        showErrorMessage: false,
      })
    }
    else if (validate && user._id && prevProps.validate !== validate) {
      sendNotification('success', intl, intl.formatMessage({ id: 'already_registered' }))
      this.setState({
        showRegisterAccountMessage: true,
        showErrorMessage: false,
        showCreatedAccountMessage: false,
      })
    }
    if (error && !validate && prevProps.error !== error && !user) {
      sendNotification('error', intl, intl.formatMessage({ id: 'error_invitation_link' }))
      this.setState({
        showErrorMessage: true,
        showRegisterAccountMessage: false,
        showCreatedAccountMessage: false,
      })
    }
  }

  handleOnInputChange = e => {
    this.setState({
      [e.target.name]: e.target.value,
    })
  }

  handleOnClick = e => {
    const { accessToken, user, group } = this.props;
    const { username, password, confirmPassword } = this.state
    if (username !== '' && password && confirmPassword) {
      const registerUser = {
        name: username,
        email: user.email.toLowerCase(),
        password: confirmPassword,
        group: group
      }
      this.props.setRegisterUser(
        registerUser, accessToken
      )
    }
  }

  handleOnHomeClick = e => {
    this.props.isDoneInvitation()
    this.props.history.push('/')
  }

  render() {

    const {
      username,
      email,
      password,
      confirmPassword,
      showErrorMessage,
      showRegisterAccountMessage,
      showCreatedAccountMessage
    } = this.state
    const { user, loading, validate, error, intl } = this.props

    return (
      <React.Fragment>
        {loading && <Loading show={loading} />}
        <div className="menu" style={{ backgroundColor: '#2E97CF' }} >
          <div className="container" ref={this.containerRef}>
            <div className="search-bar">
              <div>
                <Logo privLogo={true} />
              </div>
              <img
                alt="Bunkey"
                src="/images/bunkey-logo-mobile.svg"
                className="bunkey-logo-mobile"
              />
            </div>
            <div
              style={{ marginTop: '20px', display: 'flex', justifyContent: 'flex-end' }}>
              <a href="https://bunkeydam.com"
                style={{ color: '#ffff' }}>
                {intl.formatMessage({ id: 'go_to_bunkey' })}
              </a>
            </div>
          </div>
        </div>
        <div className="accept-inv-title-bar">
          <div className="container" style={{ marginTop: '90px' }}>
            <span>{intl.formatMessage({ id: 'welcome' })}</span>
            <p>{intl.formatMessage({ id: 'create_bunkey_account' })}</p>
          </div>
        </div>


        <div className="assets-wrapper">
          <div className="container">

            {(showErrorMessage || showRegisterAccountMessage || showCreatedAccountMessage) &&
              <div className='messages' >
                <Row>
                  <Col {...this.colProps}>
                    {showErrorMessage &&
                      <span>{intl.formatMessage({ id: 'error_invitation_link' })}</span>
                    }
                    {showRegisterAccountMessage &&
                      <span>{intl.formatMessage({ id: 'validated_mail' })}</span>
                    }
                    {showCreatedAccountMessage &&
                      <span>{intl.formatMessage({ id: 'created_mail' })}</span>
                    }
                  </Col>
                </Row>
                <Row>
                  <Col {...this.colProps} className="goBunkey">
                    <Button style={{ marginTop: 10 }} type="primary" onClick={this.handleOnHomeClick}>{intl.formatMessage({ id: 'go_to_bunkey' })}</Button>
                  </Col>
                </Row>
              </div>}

            {!error && !validate &&
              <div className='form'>
                <Row type="flex" justify="left">
                  <Col {...this.colProps}>
                    <span>Email</span>
                    <Input
                      name="email"
                      type="email"
                      value={email}
                      prefix={<Icon type="mail" style={{ color: 'rgba(0,0,0,.25)' }} />}
                      placeholder="Email"
                      disabled={true} />
                  </Col>
                </Row>
                <Row>
                  <Col {...this.colProps}>
                    <span>{intl.formatMessage({ id: 'name' })}</span>
                    <Input
                      name="username"
                      type="username"
                      defaultValue={user}
                      value={username}
                      prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />}
                      onChange={this.handleOnInputChange} />
                  </Col>
                </Row>
                <Row>
                  <Col {...this.colProps}>
                    <span>{intl.formatMessage({ id: 'login_password' })}</span>
                    <Input
                      name="password"
                      placeholder={intl.formatMessage({ id: 'create_password' })}
                      value={password}
                      prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
                      type="password"
                      onChange={this.handleOnInputChange} />
                  </Col>
                </Row>
                <Row>
                  <Col {...this.colProps}>
                    <span>{intl.formatMessage({ id: 'confirm_password' })}</span>
                    <Input
                      name="confirmPassword"
                      placeholder={intl.formatMessage({ id: 'repeat_password' })}
                      value={confirmPassword}
                      prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
                      type="password"
                      onChange={this.handleOnInputChange}
                    />
                    {password && confirmPassword && password !== confirmPassword ? <p className="claves-invalidas">{intl.formatMessage({ id: 'not_equal_passwords' })}</p> : null}
                  </Col>
                </Row>
                <Row >
                  <Col {...this.colProps} className="buttonRegister">
                    {!error &&
                      <Button
                        style={{ marginTop: 10 }}
                        type="primary"
                        onClick={this.handleOnClick}
                        disabled={confirmPassword && password !== confirmPassword}
                      >{intl.formatMessage({ id: 'enter' })}</Button>
                    }
                  </Col>
                </Row>
              </div>
            }

            <div className="containerImg" >
              <Row>
                <Col span={12}><img className="welcomeImg" src={welcomeImg} alt="welcomeImg" /></Col>
              </Row>
            </div>
          </div>
        </div>
      </React.Fragment >
    )
  }
}



const mapStateToProps = state => {
  return {
    user: state.invite.user,
    loading: state.invite.loading,
    validate: state.invite.validate,
    accessToken: state.invite.accessToken,
    group: state.invite.group,
    error: state.invite.error,
    headers: state.invite.headers

  }
}

const mapDispatchToProps = {
  validateUserInvitation,
  setRegisterUser,
  isDoneInvitation
}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(AcceptInvitation)))